import Allot from "assets/images/Allot.svg";
import AllotBlue from "assets/images/AllotBlue.svg";
import AllotTrip from "assets/images/AllotTrip.svg";
import AllotTripBlue from "assets/images/AllotTripBlue.svg";
import AllRides from "assets/images/allRides.svg";
import AllRidesBlue from "assets/images/allRidesBlue.svg";
import AssignDriver from "assets/images/assignDriver.svg";
import AssignDriverBlue from "assets/images/assignDriverBlue.svg";
import AssignVehicle from "assets/images/assignVehicle.svg";
import AssignVehicleBlue from "assets/images/assignVehicleBlue.svg";
import Bill from "assets/images/Bill.svg";
import BillBlue from "assets/images/BillBlue.svg";
import Booking from "assets/images/Booking.svg";
import BookingBlue from "assets/images/BookingBlue.svg";
import Dashboard from "assets/images/Dashboard.svg";
import DashboardBlue from "assets/images/DashboardBlue.svg";
import DispatchImge from "assets/images/dispatch.svg";
import DispatchImgeBlue from "assets/images/dispatchBlue.svg";
import Driver from "assets/images/Driver.svg";
import DriverBlue from "assets/images/DriverBlue.svg";
import Logout from "assets/images/Logout.svg";
import LogoutBlue from "assets/images/LogoutBlue.svg";
import Notification from "assets/images/Notification.svg";
import NotificationBlue from "assets/images/NotificationBlue.svg";
import Office from "assets/images/Office.svg";
import OfficeBlue from "assets/images/OfficeBlue.svg";
import Operation from "assets/images/Operation.svg";
import OperationBlue from "assets/images/OperationBlue.svg";
import Payment from "assets/images/Payment.svg";
import PaymentBlue from "assets/images/PaymentBlue.svg";
import ManageInvoiceIcon from "assets/images/ManageInvoice.svg";
import ManageInvoiceIconBlue from "assets/images/ManageInvoiceBlue.svg";
import RateCard from "assets/images/RateCard.svg";
import RateCardBlue from "assets/images/RateCardBlue.svg";
import Reservation from "assets/images/Reservation.svg";
import ReservationBlue from "assets/images/ReservationBlue.svg";
import Revenue from "assets/images/Revenue.svg";
import RevenueBlue from "assets/images/RevenueBlue.svg";
import Setting from "assets/images/Setting.svg";
import SettingBlue from "assets/images/SettingBlue.svg";
import Vehicle from "assets/images/Vehicle.svg";
import VehicleBlue from "assets/images/VehicleBlue.svg";
import Vendor from "assets/images/vendor.svg";
import VendorBlue from "assets/images/VendorBlue.svg";
import compliance from "assets/images/Compliance.svg";
import complianceBlue from "assets/images/ComplianceBlue.svg";
import Transiction from "assets/images/transiction.svg";
import TransictionActive from "assets/images/transictionActive.svg";
import configuration from 'assets/images/Configure.svg';
import ComplianceConfig from 'assets/images/ComplianceConfig.svg';
import ComplianceConfigBlue from 'assets/images/ComplianceConfigBlue.svg';
import ConfigVehicle from 'assets/images/ConfigVehicle.svg';
import ConfigVehicleBlue from 'assets/images/ConfigVehicleBlue.svg';
import FeebackConfig from 'assets/images/FeedbackConfig.svg';
import FeebackConfigBlue from 'assets/images/FeedbackConfigBlue.svg';
import FAQ from 'assets/images/FAQ.svg';
import FAQBlue from 'assets/images/FAQBlue.svg';
import RegionalUser from 'assets/images/regionalUser.svg'
import RegionalUserBlue from 'assets/images/regionalUserActive.svg'
import TollCharge from 'assets/images/TollCharge.svg';
import TollChargeBlue from 'assets/images/TollChargeBlue.svg';
import reportInActive from 'assets/images/reportInActive.svg';
import reportActive from 'assets/images/reportActive.svg';
import complaint from 'assets/images/complaint.svg';
import complaintBlue from 'assets/images/complaintBlue.svg';
import LiveTracking from 'assets/images/LiveTracking.svg';
import LiveTrackingBlue from 'assets/images/LiveTrackingBlue.svg';
import CouponWhite from 'assets/images/CouponWhite.svg';
import couponBlue from 'assets/images/couponBlue.svg';

//admin Sidebar
export const adminSidebar = [
  {
    id: 0,
    field: "Dashboard",
    path: "dashboard",
    keyword: "dashboard",
    icon: Dashboard,
    activeIcon: DashboardBlue,
  },
  {
    id: 1,
    field: 'Live tracking',
    path: 'liveTracking',
    keyword: "liveTracking",
    icon: LiveTracking,
    activeIcon: LiveTrackingBlue,
  },
  {
    id: 2,
    field: "Regional User",
    path: "regionaluser",
    keyword: "regionalmanager",
    icon: RegionalUser,
    activeIcon: RegionalUserBlue,
  },
  {
    id: 3,
    field: "City Manager",
    path: "citymanager",
    keyword: "cityManager",
    icon: Vendor,
    activeIcon: VendorBlue,
  },
  {
    id: 4,
    field: "Sub-Vendor",
    path: "sub-vendor",
    keyword: "subVendor",
    icon: Vendor,
    activeIcon: VendorBlue,
  },
  {
    id: 5,
    field: "Drivers",
    path: "driver",
    keyword: "drivers",
    icon: Driver,
    activeIcon: DriverBlue,
  },
  {
    id: 7,
    field: "Vehicle",
    path: "vehicle",
    keyword: "vehicle",
    icon: Vehicle,
    activeIcon: VehicleBlue,
  },
  {
    id: 8,
    field: "Company",
    path: "companies",
    keyword: "company",
    icon: Office,
    activeIcon: OfficeBlue,
  },
  {
    id: 9,
    field: "Reservation",
    path: "reservation",
    keyword: "reservation",
    icon: Reservation,
    activeIcon: ReservationBlue,
  },
  {
    id: 10,
    field: "Manage Invoice",
    path: "manage-invoice",
    keyword: "manageInvoice",
    icon: ManageInvoiceIcon,
    activeIcon: ManageInvoiceIconBlue,
  },
  {
    id: 3,
   field: 'Tickets',
   path: 'complaints',
   keyword: "complaints",
   icon: complaint,
   activeIcon: complaintBlue,
  },
  {
    id: 6,
    field: 'Promotion',
    path: 'promotions',
    keyword: "configuration",
    icon: CouponWhite,
    activeIcon: couponBlue,
  },
  {
    id: 10,
    field: "Operation",
    path: "operation",
    keyword: "operation",
    icon: Operation,
    activeIcon: OperationBlue,
    submenu: [
      {
        id: 11,
        subIndex: "operationSubmenu",
        field: "All Rides",
        path: "operation/allrides",
        keyword: "allRides",
        icon: AllRides,
        activeIcon: AllRidesBlue,
      },
      {
        id: 12,
        subIndex: "operationSubmenu",
        field: "Allot",
        path: "operation/allot",
        keyword: "allotTrip",
        icon: AllotTrip,
        activeIcon: AllotTripBlue,
      },
      {
        id: 13,
        subIndex: "operationSubmenu",
        field: "Dispatch",
        path: "operation/dispatch",
        keyword: "dispatch",
        icon: DispatchImge,
        activeIcon: DispatchImgeBlue,
      },
      {
        id: 14,
        subIndex: "operationSubmenu",
        field: "Billing",
        path: "operation/billing",
        keyword: "billing",
        icon: Bill,
        activeIcon: BillBlue,
      },
      {
        id: 15,
        subIndex: "operationSubmenu",
        field: "Allot Vehicle",
        path: "operation/allotvehicle",
        keyword: "allotVehicle",
        icon: AssignVehicle,
        activeIcon: AssignVehicleBlue,
      },
      {
        id: 16,
        subIndex: "operationSubmenu",
        field: "Allot Driver",
        path: "operation/allotdriver",
        keyword: "allotDriver",
        icon: AssignDriver,
        activeIcon: AssignDriverBlue,
      },
    ],
  },
  {
    id: 17,
    field: "Reports",
    path: "reports",
    keyword: "reports",
    icon: RateCard,
    activeIcon: RateCardBlue,
    submenu: [
      {
        id: 18,
        subIndex: "reportsSubMenu",
        field: "Booking",
        path: "report/booking",
        keyword: "booking",
        icon: Booking,
        activeIcon: BookingBlue,
      },
     //TODO: we have commented customer tab for B2B
      // {
      //   id: 17,
      //   subIndex: "reportsSubMenu",
      //   field: "Corporate customer",
      //   path: "report/corporatecustomer",
      //   icon: allRides,
      //   activeIcon: OperationBlue,
      // },
      {
        id: 19,
        subIndex: "reportsSubMenu",
        field: "Revenue",
        path: "report/revenue",
        keyword: "revenue",
        icon: Revenue,
        activeIcon: RevenueBlue,
      },
      {
        id: 20,
        subIndex: "reportsSubMenu",
        field: "Transaction Data",
        path: "report/mis",
        keyword: "transactionData",
        icon: Transiction,
        activeIcon: TransictionActive,
      },
      {
        id: 21,
        subIndex: "reportsSubMenu",
        field: "Generated Reports",
        path: "report-generate",
        keyword: "booking",
        icon: reportInActive,
        activeIcon: reportActive,
      }
    ],
  },

  {
    id: 22,
    field: 'Configuration',
    path: 'configuration',
    keyword: "configuration",
    icon: configuration,
    activeIcon: complianceBlue,
    submenu: [
      {
        id: 27,
        subIndex: "configurationSubMenu",
        field: 'Feedback',
        path: 'configuration/addfeedback',
        keyword: "configFeedback",
        icon: FeebackConfig,
        activeIcon: FeebackConfigBlue,
      },
      {
        id: 21,
        subIndex: "configurationSubMenu",
        field: 'Add Compliances',
        keyword: "configCompliance",
        path: 'configuration/addcomplaince',
        icon: ComplianceConfig,
        activeIcon: ComplianceConfigBlue,
      },
      {
        id:30,
        subIndex: "configurationSubMenu",
        field:"Toll Management",
        path:"configuration/tollCharges",
        keyword: "tollCharges",
        icon: TollCharge,
        activeIcon: TollChargeBlue,
      },
      {
        id: 29,
        subIndex: "configurationSubMenu",
        field: 'Vehicle Category',
        path: 'configuration/addcab',
        keyword: "vehicleCategory",
        icon: ConfigVehicle,
        activeIcon: ConfigVehicleBlue,
      },
      {
        id: 28,
        subIndex: "configurationSubMenu",
        field: 'FAQs',
        path: 'configuration/faq/Customer',
        keyword: "faq",
        icon: FAQ,
        activeIcon: FAQBlue,
      },
    ],
  },
  {
    id: 22,
    field: 'Compliance',
    path: 'compliance',
    keyword: "compliance",
    icon: compliance,
    activeIcon: complianceBlue,
  },
  {
    id: 23,
    subIndex: 4,
    field: "Settlement",
    path: "payment",
    keyword: "settlement",
    icon: Payment,
    activeIcon: PaymentBlue,
  },
  {
    id: 24,
    field: "Notification",
    path: "notification",
    keyword: "notification",
    icon: Notification,
    activeIcon: NotificationBlue,
  },
  {
    id: 25,
    field: "Settings",
    path: "settings",
    keyword: "settings",
    icon: Setting,
    activeIcon: SettingBlue,
  },
  {
    id: 26,
    field: "Logout",
    keyword: "Logout",
    path: "",
    icon: Logout,
    activeIcon: LogoutBlue,
  },
];

//Operation Module Sidebar
export const commonSideData = [
  {
    id: 27,
    field: "Settings",
    path: "settings",
    icon: Setting,
    activeIcon: SettingBlue,
  },
  {
    id: 28,
    field: "Logout",
    path: "",
    icon: Logout,
    activeIcon: LogoutBlue,
  },
];
